const CURSOR_OVERLAP_MS = 5 * 60 * 1000;

export function getSyncSince(lastSyncAt: string, localItemCount: number) {
  if (!lastSyncAt) return localItemCount ? new Date(0).toISOString() : '';

  const parsed = Date.parse(lastSyncAt);
  if (!Number.isFinite(parsed)) return new Date(0).toISOString();
  return new Date(Math.max(0, parsed - CURSOR_OVERLAP_MS)).toISOString();
}
